import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Card,
  CardBody,
  Label,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import Confirm from "components/Confirm";
import { Formik, Field } from "formik";
import { dateFormate } from "utils/columns";
import { ModuleAccess } from "utils/moduleaccess";
import save from "assets/icon/save.svg";

let inActiveStatuObj = [
  { id: "Y", label: "Yes" },
  { id: "N", label: "No" },
];

const CEContractConfig = ({
  contractId,
  toggle,
  claimStatusLKP,
  pharmacyName,
  module,
}) => {
  const API = useAxios();
  const [loading, setLoading] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [isConfirm, setConfirm] = useState(false);
  const [displayEDMode, setDisplayEDMode] = useState(false);
  const [finalData, setFinalData] = useState([]);

  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
    //return (module && module.actions.indexOf(code) != -1)
  };

  useEffect(() => {
    setDisplayEDMode(!hasPermission("ED"));
    fetchCEContractConfig();
  }, []);

  const fetchCEContractConfig = async () => {
    const { data } = await API.get(
      `Config/ceconfig/cecontractconfig/${contractId}`,
      {
        hideLoader: true,
      }
    );
    if (data) {
      setFinalData(data);
      setConfigData(data);
    }
  };

  const onChangeHandler = (item, e) => {
    finalData.map((c) => {
      if (c.rcmContractDefaultConfigID == item.rcmContractDefaultConfigID) {
        c.configValue = e.target.value;
        console.log("value matched");
      }
    });
  };

  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };

  const handleSubmit = async () => {
    handleSaveConfirmation();
    setLoading(true);
    let ceContractConfig = {};
    ceContractConfig.ContractID = contractId;
    ceContractConfig.cEContractConfigModel = finalData;
    try {
      const result = await API.post(
        `Config/ceconfig/updatececontractconfig/${contractId}`,
        ceContractConfig
      );
      toast.success("Contract configuration saved successfully");
      if (result) {
        setLoading(false);
        toggle(true);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const renderSave = () => {
    if (hasPermission("ED")) {
      return (
        <Button
          color="primary"
          className="search"
          onClick={handleSaveConfirmation}
          style={{ float: "right" }}
          disabled={disabled}
        >
          <span className="right_5">
            <img src={save} alt="" />
          </span>{" "}
          Save
        </Button>
      );
    }
  };

  const handleChange = (e, item) => {
    item.configValue = e.target.value;
  };

  const renderCtrl = (item) => {
    if (item.code == "EFRF") {
      return (
        <Input
          type="select"
          defaultValue={item.configValue}
          hidden={displayEDMode}
          onChange={(e) => handleChange(e, item)}
          style={{ width: "225px" }}
        >
          <option value={""}>--Select--</option>
          {inActiveStatuObj.map((status) => {
            const { id, label } = status;
            return (
              <option key={id} value={id}>
                {label}
              </option>
            );
          })}
        </Input>
      );
    } else if (item.code == "FRS") {
      return (
        <Input
          type="select"
          defaultValue={item.configValue}
          hidden={displayEDMode}
          onChange={(e) => handleChange(e, item)}
          style={{ width: "225px" }}
        >
          <option value={""}>--Select--</option>
          {claimStatusLKP.map((status) => {
            const { id, description } = status;
            return (
              <option key={id} value={id}>
                {description}
              </option>
            );
          })}
        </Input>
      );
    } else {
      return (
        <input
          style={{ width: "225px" }}
          className="form-control"
          hidden={displayEDMode}
          type="text"
          defaultValue={item.configValue}
          onChange={(e) => onChangeHandler(item, e)}
        />
      );
    }
  };

  return (
    <div>
      <Formik>
        <div>
          <Card className="border-0 shadow-top">
            <CardBody className="section-devider-border">
              <Row>
                <Col>
                  <FormGroup>
                    <Label for="pharmacyName">Pharmacy Name</Label>
                    <br />
                    <b className="d-inline-block font-weight-500">
                      {`${pharmacyName || "-"} `}
                    </b>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className="border-0 shadow-top mt-2">
            <CardBody className="section-devider-border">
              <Row>
                <Col>
                  <div className="table-card scroll-table position-relative border-0 rounded pt-0">
                    <div className="rounded-table">
                      <div className="table-responsive">
                        <table
                          id="reactstrap-table"
                          className="table table-striped theme-table undefined table"
                        >
                          <thead>
                            <tr>
                              <th width="144">Description</th>
                              <th width="144">Config Value</th>
                              <th width="144">Default Config Value</th>
                              <th width="144">Modified Date</th>
                              <th width="144">Modified By</th>
                            </tr>
                          </thead>
                          <tbody>
                            {configData.map((item, index) => (
                              <tr key={item.rcmContractDefaultConfigID}>
                                <td>{item.description}</td>
                                <td>
                                  {renderCtrl(item)}
                                  <div hidden={!displayEDMode}>
                                    <b className="d-inline-block ps-2 font-weight-500">
                                      {`${item.configValue || "-"} `}
                                    </b>
                                  </div>
                                </td>
                                <td>{item.defaultConfigValue}</td>
                                <td>{dateFormate(item.modifiedDate)}</td>
                                <td>{item.modifiedBy}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div>&nbsp;</div>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {renderSave()}
                    </div>
                    <Confirm
                      isOpen={isConfirm}
                      loading={loading}
                      message="Are you sure you want to save?"
                      onToggle={handleSaveConfirmation}
                      onCancel={handleSaveConfirmation}
                      onContinue={handleSubmit}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Formik>
    </div>
  );
};
export default CEContractConfig;
